import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ListComponent from '../../../../core/infraestructure/ListComponent';
import DiscountViewModel from '../../../../core/features/discount/viewmodels/DiscountViewModel';

export default {
  extends: ListComponent,
  data() {
    return {
      modulePermissions: 'DiscountContent-Discounts',
      item: null,
      searchName: null,
      searchCode: null,
      searchMax: null,
      searchAmount: null,
      reportDate: null,
      subscriptionPlans: [],
      viewModel: null,
      filterOptions: {
        subscriptionPlanFilter: '',
      },
      modalImport: {
        isVisible: false,
        isLoading: false,
        title: 'IMPORTAR DESCUENTOS',
        onUploadImport: 'onUploadImportDiscount',
        onCancelImport: 'onCancelImportDiscount'
      },
      modalHistory: {
        isVisible: false,
        isLoading: false,
        title: 'HISTORIAL CUPONES USADOS',
        onAcceptHistory: 'onAcceptHistoryDiscount'
      }
    };
  },
  computed: {
    hasActiveFilters() {
      const hasPlan = Boolean(
        this.filterOptions &&
        this.filterOptions.subscriptionPlanFilter &&
        (this.filterOptions.subscriptionPlanFilter.id || this.filterOptions.subscriptionPlanFilter.name || this.filterOptions.subscriptionPlanFilter)
      );
      const hasDate = Boolean(this.reportDate && this.reportDate.length);
      return Boolean(
        this.searchCode ||
        this.searchName ||
        this.searchAmount ||
        this.searchMax ||
        hasDate ||
        hasPlan
      );
    },
    activeFiltersCount() {
      let count = 0;
      if (this.searchCode) count++;
      if (this.searchName) count++;
      if (this.searchAmount) count++;
      if (this.searchMax) count++;
      if (this.reportDate && this.reportDate.length) count++;
      if (
        this.filterOptions &&
        this.filterOptions.subscriptionPlanFilter &&
        (this.filterOptions.subscriptionPlanFilter.id || this.filterOptions.subscriptionPlanFilter.name || this.filterOptions.subscriptionPlanFilter)
      ) {
        count++;
      }
      return count;
    }
  },
  mounted() {
    EventBus.$on('onSubmitedDiscount', this.onSearch);
    EventBus.$on('onUploadImportDiscount', this.onUploadImport);
    EventBus.$on('onCancelImportDiscount', this.onCancelImport);
    EventBus.$on('onAcceptHistoryDiscount', this.onAcceptHistory);
  },
  beforeDestroy() {
    EventBus.$off('onSubmitedDiscount', this.onSearch);
    EventBus.$off('onUploadImportDiscount', this.onUploadImport);
    EventBus.$off('onCancelImportDiscount', this.onCancelImport);
    EventBus.$off('onAcceptHistoryDiscount', this.onAcceptHistory);
  },
  created() {
    this.viewModel = new DiscountViewModel(this);
    this.onActive();
  },
  methods: {
    onActive() {
      this.onSearch();
    },
    onAllFilterChange(data, field) {
      this.onFilterChange(data, field);
    },
    onFilterDate(data, field) {
      this.viewModel.updateFilters(data, field, '=');
    },
    onRangeDate(data, startDate, endDate) {
      if (data && data.length === 2) {
        this.onFilterDate(data[0], startDate);
        this.onFilterDate(data[1], endDate);
        this.onSearch();
      } else {
        this.viewModel.removeFilter(startDate);
        this.viewModel.removeFilter(endDate);
        this.onSearch();
      }
    },
    onSearchSubscriptionPlans(data) {
      if (data) {
        this.viewModel.onSearchSubscriptionPlans(data);
      } else {
        this.subscriptionPlans = [];
      }
    },
    onSearchSubscriptionPlansResponse(response) {
      this.subscriptionPlans = (response.data || []).filter(Boolean);
    },
    onShowImport() {
      this.viewModel.showModal(this.modalImport, true);
    },
    onUploadImport(file) {
      this.viewModel.showModalLoading(this.modalImport, true);
      this.viewModel.import(file);
    },
    onCancelImport() {
      this.viewModel.showModal(this.modalImport, false);
    },
    onExportToExcel() {
      this.viewModel.exportToExcel();
    },
    onShowHistory() {
      this.viewModel.showModal(this.modalHistory, true);
    },
    onAcceptHistory() {
      this.viewModel.showModal(this.modalHistory, false);
    },
    onCanCreate() {
      return this.canCreate(this.modulePermissions);
    },
    onCanRead() {
      return this.canRead(this.modulePermissions);
    },
    onCanUpdate() {
      return this.canUpdate(this.modulePermissions);
    },
    onCanDelete() {
      return this.canDelete(this.modulePermissions);
    },
    isDiscountExpired(endDate) {
      if (!endDate) return false;
      const end = new Date(endDate);
      if (isNaN(end.getTime())) return false;
      end.setHours(23, 59, 59, 999);
      return end.getTime() < Date.now();
    },
    getAvailabilityStatus(row) {
      if (!row) {
        return { type: 'available', label: 'Disponible', icon: 'fas fa-check-circle' };
      }
      const val = Number(row.availability);
      if (isNaN(val) || val <= 0) {
        return { type: 'exhausted', label: 'Agotado', icon: 'fas fa-times-circle' };
      }
      if (val <= 5) {
        return { type: 'warning', label: `${val} restantes`, icon: 'fas fa-exclamation-circle' };
      }
      return { type: 'available', label: `${val} disponibles`, icon: 'fas fa-check-circle' };
    },
    onClearFilter(field, modelKey) {
      if (modelKey && this[modelKey] !== undefined) {
        this[modelKey] = null;
      }
      if (this.viewModel) {
        this.viewModel.removeFilter(field);
      }
      this.onSearch();
    },
    onResetAllFilters() {
      this.searchCode = null;
      this.searchName = null;
      this.searchAmount = null;
      this.searchMax = null;
      this.reportDate = null;
      if (this.filterOptions) {
        this.filterOptions.subscriptionPlanFilter = '';
      }
      this.filters = [];
      if (this.viewModel) {
        this.viewModel.filters = [];
      }
      this.onSearch();
    }
  }
};
